import styled from 'styled-components';

const URLPreview = styled.div`
  padding: 14px 25px;
  width: fit-content;
  margin-top: 0;

  font-family: 'Basier Circle';
  font-size: 15px;
  font-style: normal;
  font-weight: 400;
  line-height: 18px;
  letter-spacing: -0.2px;
  text-align: center;
  color: #000;

  background: #ffffff;
  border: 1px solid #dddddd;
  box-sizing: border-box;
  border-radius: 75px;

  @media only screen and (min-device-width: 320px) and (max-device-width: 480px) {
    display: flex;
    justify-content: center;
    padding: 14px 20px;
  }
`;

export default URLPreview;



// WEBPACK FOOTER //
// ./src/components/Utility/URLPreview/index.jsx